<template>
	<div>
		<div style="margin-top:2px">
			<filterInput :filter="filter" @fetchDynamicHierarchyList="fetchDynamicHierarchyList"/>
		</div>
		<div class="col-md-12 row sub" style="padding-right:0px;margin-top:14px">
			<span
				class="span-label col-md-5 text-xs-center"
				style="padding:0px !important;margin-top:2px"
			>{{filter.subHierarchy.label}}</span>
			<toggle-button
				class="col-md-1"
				style="padding:0px !important;margin-left:34px;margin-top:2px"
				v-if="!filter.subHierarchy.readonly"
				v-model="filter.subHierarchy.enabled"
				@change="swap(filter.subHierarchy)"
				:sync="true"
				color="#3da3a7"
			/>
			<div
				class="col-md-12"
				v-if="filter.enabled"
				style="background-color:#f5f5f5 !important;padding:0px !important;margin-left:270px;margin-top:-30px;position:relative;"
			>
				<filterInput
					v-if="filter.subHierarchy.enabled"
					@fetchDynamicSubHierarchyList="fetchDynamicSubHierarchyList"
					:filter="filter.subHierarchy"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import Multiselect from "vue-multiselect";
	import filterInput from "./filterInput";
	import moment from "moment";
	export default {
		components: { Multiselect, filterInput },
		props: { filter: { type: Object, required: true } },

		watch: {},
		computed: {},
		data() {
			return {};
		},
		methods: {
			swap(filter) {
				this.$emit("toggle", filter);
			},
			fetchDynamicSubHierarchyList(search, type) {
				const vm = this;
				var obj = {
					str: search,
					go_vendor_cd: this.filter.value ? this.filter.value.id : ""
				};
				if (type == "Select campaign group")
					this.$store
						.dispatch("campaign/fetchDynamicCampGrpList", obj)
						.then(res => {
							vm.filter.subHierarchy.values = res ? res : [];
						});
				else if (type == "Select brand profile") {
					this.$store.dispatch("getAllBrandProfile", obj).then(res => {
						vm.filter.subHierarchy.values = res ? res : [];
					});
				}
			},
			fetchDynamicHierarchyList(search) {
				const vm = this;
				var obj = {
					str: search
				};
				this.$store.dispatch("getAllVendor", obj).then(res => {
					vm.filter.values = res ? res : [];
				});
			}
		}
	};
</script>

<style lang="scss">
.sub {
	position: relative !important;
	margin-left: -284px !important;
}
</style>

